/* tslint:disable:no-shadowed-variable */
import camelcaseKeysDeep from 'camelcase-keys-deep'
import { ModuleNames } from '@/store/module-names'
import { MonthlyCostsState } from './types'
import { ActionNames, MutationNames } from './keys'
import { getters } from './getters'
import { callApiWithoutDuplicate } from '@/store/utils/api'
import { GetMonthlyCostsDto, getMonthlyCostsQuery, setMonthlyCostsQuery } from '@/jsonapi/MonthlyCosts'

const state: MonthlyCostsState = {
  monthlyCosts: [],
}

const mutations = {
  [MutationNames.updateCosts](state, payload): void {
    state.monthlyCosts = payload
  },
}

const actions = {
  async [ActionNames.getCosts]({ commit, rootGetters }, payload?: GetMonthlyCostsDto): Promise<void> {
    await callApiWithoutDuplicate({
      commit,
      rootGetters,
      actionName: ActionNames.getCosts,
      params: payload,
      fn: async () => {
        const result = camelcaseKeysDeep(await getMonthlyCostsQuery(payload))
        commit(MutationNames.updateCosts, result)
      },
    })
  },
  async [ActionNames.patchCosts]({ commit }, payload) {
    await setMonthlyCostsQuery(payload)
    const results = camelcaseKeysDeep(await getMonthlyCostsQuery(payload))
    commit(MutationNames.updateCosts, results)
  },
}

export default {
  name: ModuleNames.monthlyCosts,
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
